import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthServiceService } from '../../../core/http/auth-service.service';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ObsService } from '../../../core/http/obs.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  isLoading = true;
  Errors = null;
  mode = null;
  users = null;
  data = null;
  employees: any = [];
  types: any = [];
  Success = null;
  filterddata: any = [];
  change: any = [];
  position: any = [];
  private _searchText: string;
  points = [];
  signatureImage;
  type = 'form';
  new = 'form1';
  id;
  enable;
  return: any;
  disable;
  position_main;
  currentUser: any = {};
  fileName = 'ExcelSheet.xlsx';
  base64Image?: string;
  signatureUpload = false;

  showImage(data) {
    this.signatureImage = data;
    this.type = 'form';
    this.stateForm.patchValue({
      signature: data,
    });
    console.log(this.stateForm.value);
  }

  showImage1(data) {
    this.signatureImage = data;
    this.new = 'form1';
    this.stateForm.patchValue({
      signature: data,
    });
    console.log(this.stateForm.value);
  }
  addSign() {
    this.type = 'sign';
  }
  addSign1() {
    this.new = 'sign1';
  }

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value);
  }

  filterdata(searchString: string) {
    return this.users.filter(
      (log) =>
        log.First_Name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }

  stateForm = new FormGroup({
    Employee_id: new FormControl('', Validators.required),
    First_Name: new FormControl('', Validators.required),
    Middle_Name: new FormControl('', Validators.required),
    Last_Name: new FormControl('', Validators.required),
    U_Name: new FormControl('', Validators.required),
    Position_Id: new FormControl('', Validators.required),
    Address: new FormControl('', Validators.required),
    Phone_No: new FormControl('', Validators.required),
    Email_id: new FormControl('', Validators.required),
    Flag: new FormControl('', Validators.required),
    designation: new FormControl('', Validators.required),
    signature: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    IsDeleted: new FormControl(null),
    qualification: new FormControl(''),
    CanAuthDiscount: new FormControl(''),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: AuthServiceService,
    private obs: ObsService,
    public set: SettingsService
  ) {}

  isUserActive(user): boolean {
    return !user.IsDeleted;
  }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    console.log(this.stateForm.value);

    const {
      Employee_id,
      First_Name,
      Middle_Name,
      Last_Name,
      U_Name,
      Position_Id,
      Address,
      Phone_No,
      Email_id,
      Flag,
      designation,
      signature,
      password,
      IsDeleted,
      qualification,
      CanAuthDiscount,
    } = this.stateForm.value;
    this.set
      .postUser(
        Employee_id,
        First_Name,
        Middle_Name,
        Last_Name,
        U_Name,
        Position_Id,
        Address,
        Phone_No,
        Email_id,
        Flag,
        designation,
        signature,
        password,
        IsDeleted,
        qualification,
        CanAuthDiscount
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this._snackBar.open('Error something went wrong', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(resSuccess);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }
  deactivate() {
    this.set.disableUser(this.id).subscribe(
      (resSuccess) => {
        this.disable = resSuccess;
        this._snackBar.open(this.disable.message, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  // activate() {
  //   this.set.enableUser(this.id).subscribe(
  //     (resSuccess) => {
  //       this.enable = resSuccess;
  //       this._snackBar.open(this.enable.message, '', {
  //         duration: 2000,
  //         verticalPosition: 'top',
  //       });
  //       console.log(resSuccess);
  //     },
  //     (resErr) => {
  //       this.Errors = resErr;
  //     }
  //   );
  // }

  activate(user): void {
    this.id = user.Employee_id;
    this.set.enableUser(this.id).subscribe(
      (resSuccess) => {
        this.enable = resSuccess;
        this._snackBar.open(this.enable.message, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  ngOnInit(): void {
    this.obs.getDropdownValues(32).subscribe(
      (resSuccess) => {
        this.position = resSuccess;
      },
      (resErr) => {}
    );
    this.set.getEmployees().subscribe(
      (resSuccess) => {
        this.employees = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    // this.set
    // .getDesignation()
    // .subscribe(
    //   (resSuccess) => {

    //     this.position = resSuccess
    //     console.log(this.position);

    //   },
    //   (resErr) => {
    //     this.Errors = resErr;
    //   }
    // );

    this.set.getCategories().subscribe(
      (resSuccess) => {
        this.types = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    this.set.getUser().subscribe(
      (resSuccess) => {
        this.users = resSuccess;
        console.log(this.users);
        this.filterddata = this.users;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  remoteUser() {
    this.signatureUpload = !this.signatureUpload;
  }
  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.signatureImage = e.target.result;
        console.log(this.signatureImage); // You can see the base64 string in the console
        this.stateForm.patchValue({
          signature: this.signatureImage,
        });
      };
      reader.readAsDataURL(file);
    }
  }
  addNew() {
    this.mode = 'add';
  }
  Deactivate(user) {
    this.set.deactivate(user.Employee_id).subscribe(
      (resSuccess: any) => {
        console.log(resSuccess);
        if (resSuccess.success) {
          this._snackBar.open('User Deactivated Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this._snackBar.open('Error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.Errors = resErr;
        this._snackBar.open('Error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  edit(title) {
    this.mode = 'edit';
    console.log(title);
    this.id = title.Employee_id;

    this.set.getUserById(title.Employee_id).subscribe(
      (resSuccess: any) => {
        this.signatureImage = resSuccess[0].signature;
        this.return = resSuccess;
        this.stateForm.patchValue({
          Employee_id: resSuccess[0].Employee_id,
          First_Name: resSuccess[0].First_Name,
          Middle_Name: resSuccess[0].Middle_Name,
          Last_Name: resSuccess[0].Last_Name,
          U_Name: resSuccess[0].U_Name,
          Position_Id: resSuccess[0].Position_Id,
          Address: resSuccess[0].Address,
          Phone_No: resSuccess[0].Phone_No,
          Email_id: resSuccess[0].Email_id,
          Flag: resSuccess[0].Flag,
          designation: resSuccess[0].designation,
          signature: resSuccess[0].signature,
          password: resSuccess[0].password,
          qualification: resSuccess[0].qualification,
          CanAuthDiscount: resSuccess[0].CanAuthDiscount,
        });
        console.log(this.stateForm.value);
        this.set.getUserById(title.Employee_id).subscribe(
          (resSuccess: any) => {
            this.signatureImage = resSuccess[0].signature;
            this.return = resSuccess[0];

            this.stateForm.patchValue({
              Employee_id: resSuccess[0].Employee_id,
              First_Name: resSuccess[0].First_Name,
              Middle_Name: resSuccess[0].Middle_Name,
              Last_Name: resSuccess[0].Last_Name,
              U_Name: resSuccess[0].U_Name,
              Position_Id: resSuccess[0].Position_Id,
              Address: resSuccess[0].Address,
              Phone_No: resSuccess[0].Phone_No,
              Email_id: resSuccess[0].Email_id,
              Flag: resSuccess[0].Flag,
              designation: resSuccess[0].designation,
              signature: resSuccess[0].signature,
              password: resSuccess[0].password,
              qualification: resSuccess[0].qualification,
              CanAuthDiscount: resSuccess[0].CanAuthDiscount,
            });
            console.log(this.stateForm.value);
            let currentUser = this.position.filter(
              (t) => t.OptionValue == resSuccess[0].Position_Id
            );
            console.log(currentUser);
            this.position_main = currentUser[0].OptionName;
          },
          (resErr) => {
            this.Errors = resErr;
          }
        );
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    console.log(this.stateForm.value);
  }
  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
